module.exports = __webpack_public_path__ + "static/media/twitter.d3b7c3b2.svg";